import { addressMapper, geoMapper } from '../actions/submitForm/utils/mappers';
import { EDealTypeEx } from '../repositories/demand/entities/public_v5_create_message/RequestMessageV5Schema';

export const getGeoMapper = (dealTypeEx: EDealTypeEx) => {
  if (dealTypeEx === EDealTypeEx.Sale || dealTypeEx === EDealTypeEx.SellToBuy || dealTypeEx === EDealTypeEx.Rent) {
    return addressMapper;
  } else {
    return geoMapper;
  }
};
